import { render, staticRenderFns } from "./ImportQuestionsHandler.vue?vue&type=template&id=3950d276"
import script from "./ImportQuestionsHandler.vue?vue&type=script&lang=js"
export * from "./ImportQuestionsHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports